export default async ({
  id = ''
}, options = {
  showError: true
}) => {
  const [content, error, status] = await POST(URLS.admin.toggleUserLocked, {
    id
  }, options);
  if (error) return {
    error,
    status
  };
  return content || {};
};